import { UncubesQuery } from '@dynameat/views/reporting/models';

export class ProcessingSpeedQuery extends UncubesQuery {
  projection = 'ticket_sales'

  cuts = []

  cols = [
    { kpi: 'product_processing_speed' }
  ]

  limit = 1

  constructor(productGuid) {
    super();
    this.cuts = [
      { expression: `product_guid = '${productGuid}'` }];
  }
}
